import type { Edge, Node } from '@xyflow/react'
import { allCookbookRecipes } from '@/features/backtest/cookbook'
import { templateAsStrategy } from '@/features/backtest/cookbook/apply-recipe'

/**
 * The create_strategy_template names, each built as the cookbook template it
 * stands for, as a whole strategy: the default chain with the template in the
 * Trade Manager's slot, as the editor's examples land it (the 2026-10-06
 * vocabulary swap). The hand-built graphs these names used to make wired
 * outputs the nodes do not have (`output_1`) into Entry Rules and the old
 * trade nodes.
 */
const TEMPLATE_KEYS: Record<string, string> = {
  sma_crossover: 'ma-crossover',
  rsi_reversal: 'rsi-threshold',
  breakout: 'opening-range-break',
  mean_reversion: 'rsi-pullback-reset',
}

export interface StrategyTemplate {
  nodes: Node[]
  edges: Edge[]
}

/** The strategy a template name builds, with the template's own settings; null for an unknown name. */
export function getTemplate(name: string): StrategyTemplate | null {
  const entry = allCookbookRecipes.find((e) => e.key === TEMPLATE_KEYS[name])
  if (!entry) return null
  const graph = templateAsStrategy(entry)
  return graph.ok ? { nodes: graph.nodes as Node[], edges: graph.edges as Edge[] } : null
}

export function getTemplateNames(): string[] {
  return Object.keys(TEMPLATE_KEYS)
}
